import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { GuaranteeRefundComponent } from './component/guaranteeRefund.component';
import { ContractsModule } from '../../dossiers/contracts/contracts.module';

@NgModule({
  declarations: [GuaranteeRefundComponent],
  imports: [
    CommonModule,
    FormPlycaModule,
    ContractsModule
  ],
  exports: [GuaranteeRefundComponent]
})
export class GuaranteeRefundModule {

}